import { getCzechTimeTranslationKey } from 'utils/translate';
import useRefreshDelay from 'hooks/useRefreshDelay';
import { translate } from '../../utils';
import Button, { Props as ButtonProps } from './Button';

interface Props extends Omit<ButtonProps, 'onClick' | 'children'> {
  delaySeconds: number;
  onRefresh: () => void;
  text?: string;
}

export default function RefreshButton({
  delaySeconds,
  onRefresh,
  text,
  disabled,
}: Props) {
  const { isDisabled, remainingSeconds, handleRefresh } = useRefreshDelay({
    delaySeconds,
    onRefresh,
  });
  const isButtonDisabled = disabled || isDisabled;

  return (
    <div className="flex flex-col items-center">
      {isButtonDisabled && (
        <span className="text-muted h-7">
          {`${translate(
            'welcome_back.check_again_in',
          )} ${remainingSeconds} ${translate(
            getCzechTimeTranslationKey(remainingSeconds, 'time.seconds'),
          )}`}
        </span>
      )}
      <Button disabled={isButtonDisabled} onClick={handleRefresh}>
        {text}
      </Button>
    </div>
  );
}
